
import { MessageCircle } from "lucide-react";

interface Message {
  id: number;
  from: string;
  content: string;
  timestamp: string;
  unread: boolean;
}

interface MessagesTabProps {
  messages: Message[];
}

export const MessagesTab = ({ messages }: MessagesTabProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-green-800">Messages</h3>
      {messages.length === 0 ? (
        <div className="text-center py-8">
          <MessageCircle className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-500 mb-2">No messages yet</p>
          <p className="text-sm text-gray-400">Connect with other farmers in the community!</p>
        </div>
      ) : (
        <div className="space-y-3">
          {messages.map((message) => (
            <div 
              key={message.id} 
              className={`p-4 rounded-lg border ${
                message.unread 
                  ? 'bg-green-50 border-green-200' 
                  : 'bg-gray-50 border-gray-200'
              }`}
            >
              <div className="flex justify-between items-start mb-2">
                <span className="font-medium text-green-800">{message.from}</span>
                <span className="text-xs text-gray-500">{message.timestamp}</span>
              </div>
              <p className="text-gray-700">{message.content}</p>
              {message.unread && (
                <div className="mt-2">
                  <span className="bg-green-600 text-white text-xs px-2 py-1 rounded-full">New</span>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
